import React from 'react'
import { Image } from 'utoniq-ui'

type Props = { withBorderRadius?: boolean } & Pick<
  React.ComponentProps<'img'>,
  'width' | 'height' | 'src' | 'alt'
>
export const ThumbnailImage = ({
  src,
  alt,
  withBorderRadius = false,
  width,
  height,
}: Props) => (
  <Image
    style={{
      width: width ?? '100%',
      height: height ?? '100%',
      borderRadius: withBorderRadius ? '8px' : 'inherit',
      objectFit: 'cover',
    }}
    alt={alt}
    src={src}
  />
)
